import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

const headerStyle = {
  background:
    "linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 25%, rgba(8,177,5,1) 62%, rgba(0,212,255,1) 100%)",
  color: "white",
};

const HeaderBar = ({ title = { pageTitle: "Page Title Placeholder" } }) => (
  <div className="header">
    <AppBar position="static" color="default" style={headerStyle}>
      <Toolbar>
        <Typography variant="title" color="inherit">
          {title.pageTitle || "Page Title Placeholder"}
        </Typography>
      </Toolbar>
    </AppBar>
  </div>
);

export default HeaderBar;
